(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inner-circle-gallery"] && !Shopify.designMode) return;
  try {
    
  class ArtistAudioPlayer extends HTMLElement {
    connectedCallback() {
      this.audio = this.querySelector('audio');
      this.button = this.querySelector('.ic-audio__button');
      this.time = this.querySelector('[data-time]');
      this.fill = this.querySelector('[data-fill]');
      if (!this.audio || !this.button) return;

      this.onToggle = this.toggle.bind(this);
      this.onTime = this.updateProgress.bind(this);
      this.onMeta = this.updateProgress.bind(this);
      this.onEnded = this.reset.bind(this);
      this.onStop = this.stop.bind(this);

      this.playLabel = this.dataset.playLabel || 'Play audio';
      this.pauseLabel = this.dataset.pauseLabel || 'Pause audio';
      this.button.setAttribute('aria-label', this.playLabel);
      this.button.addEventListener('click', this.onToggle);
      this.audio.addEventListener('timeupdate', this.onTime);
      this.audio.addEventListener('loadedmetadata', this.onMeta);
      this.audio.addEventListener('ended', this.onEnded);
      this.addEventListener('lk:stop', this.onStop);
      this.updateProgress();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onToggle);
      this.audio?.removeEventListener('timeupdate', this.onTime);
      this.audio?.removeEventListener('loadedmetadata', this.onMeta);
      this.audio?.removeEventListener('ended', this.onEnded);
      this.removeEventListener('lk:stop', this.onStop);
    }

    format(seconds) {
      if (!Number.isFinite(seconds) || seconds < 0) return '';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }

    stopOthers() {
      document.querySelectorAll('artist-audio-player.is-on').forEach((player) => {
        if (player !== this) player.dispatchEvent(new CustomEvent('lk:stop'));
      });
    }

    toggle(event) {
      event.preventDefault();
      if (this.audio.paused) {
        this.stopOthers();
        this.audio.play();
        this.classList.add('is-on');
        this.button.setAttribute('aria-label', this.pauseLabel);
      } else {
        this.audio.pause();
        this.classList.remove('is-on');
        this.button.setAttribute('aria-label', this.playLabel);
      }
    }

    stop() {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.classList.remove('is-on');
      this.button?.setAttribute('aria-label', this.playLabel);
      this.updateProgress();
    }

    reset() {
      this.classList.remove('is-on');
      this.audio.currentTime = 0;
      this.button?.setAttribute('aria-label', this.playLabel);
      this.updateProgress();
    }

    updateProgress() {
      const duration = this.audio.duration;
      const current = this.audio.currentTime || 0;
      if (this.fill && Number.isFinite(duration) && duration > 0) {
        this.fill.style.width = `${(current / duration) * 100}%`;
      }
      if (this.time && Number.isFinite(duration) && duration > 0) {
        const remaining = Math.max(duration - current, 0);
        this.time.textContent = this.format(this.classList.contains('ic-audio--pill') ? remaining : duration);
      }
    }
  }

  class InnerCircleGallery extends HTMLElement {
    connectedCallback() {
      this.works = Array.from(this.querySelectorAll('[data-ic-work]'));
      this.dotsWrap = this.querySelector('[data-ic-dots]');
      this.currentEl = this.querySelector('[data-ic-current]');
      this.prevBtn = this.querySelector('[data-ic-prev]');
      this.nextBtn = this.querySelector('[data-ic-next]');
      this.collection = this.querySelector('.ic-works');
      this.index = 0;
      if (!this.works.length || !this.dotsWrap) return;

      this.works.forEach((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        const label = this.dataset.workLabel || 'Go to work';
        button.setAttribute('aria-label', `${label} ${index + 1}`);
        button.addEventListener('click', () => this.go(index));
        this.dotsWrap.appendChild(button);
      });
      this.dots = Array.from(this.dotsWrap.children);
      const totalEl = this.querySelector('[data-ic-total]');
      if (totalEl) totalEl.textContent = String(this.works.length).padStart(2, '0');

      this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
      this.onKey = (event) => {
        if (event.target.matches('input, textarea, select')) return;
        if (event.key === 'ArrowRight') this.nextBtn?.click();
        if (event.key === 'ArrowLeft') this.prevBtn?.click();
      };
      document.addEventListener('keydown', this.onKey);
      this.go(0, true);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    go(nextIndex, keepScroll) {
      if (nextIndex < 0 || nextIndex >= this.works.length) return;
      this.querySelectorAll('artist-audio-player.is-on').forEach((player) => {
        player.dispatchEvent(new CustomEvent('lk:stop'));
      });
      this.works[this.index].classList.remove('is-active');
      this.works[this.index].hidden = true;
      this.index = nextIndex;
      this.works[this.index].classList.add('is-active');
      this.works[this.index].hidden = false;
      if (this.currentEl) this.currentEl.textContent = String(this.index + 1).padStart(2, '0');
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.works.length - 1;
      if (!keepScroll && this.collection) {
        const top = this.collection.getBoundingClientRect().top + window.scrollY - 12;
        if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('artist-audio-player')) {
    customElements.define('artist-audio-player', ArtistAudioPlayer);
  }
  if (!customElements.get('inner-circle-gallery')) {
    customElements.define('inner-circle-gallery', InnerCircleGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
